import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useCurrentUser } from '@contexts/currentUser'
import { useAnalytics } from '@contexts/analytics'
import ImpersonationSidebar from '@components/ImpersonationSidebar'
import FlashMessage from '@components/FlashMessage'

const Layout = () => {
  const location = useLocation()
  const { page } = useAnalytics()

  const { user: { impersonating, loading } } = useCurrentUser()

  useEffect(() => {
    page()
  }, [location])

  if (loading) return

  return (
    <>
      <FlashMessage />
      <div id='main-layout' className='flex flex-row h-full'>
        <Outlet />
        <If condition={impersonating}>
          <div className='absolute top-0 w-full h-[10px] min-h-[10px] bg-orange-500 z-10' />

          <ImpersonationSidebar />
        </If>
      </div>
    </>
  )
}

export default Layout
